import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import Select from 'react-select'
import "../assets/styles/home.scss"
const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLschedule2025/prod/AFLschedule2025.json'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      data: [], // undefined,
      roundOptions: [
        { "value": "All", "label": "All Rounds" },
        { "value": "0", "label": "Round 0" },
        { "value": "1", "label": "Round 1" },
        { "value": "2", "label": "Round 2" },
        { "value": "3", "label": "Round 3" },
        { "value": "4", "label": "Round 4" },
        { "value": "5", "label": "Round 5" },
        { "value": "6", "label": "Round 6" },
        { "value": "7", "label": "Round 7" },
        { "value": "8", "label": "Round 8" },
        { "value": "9", "label": "Round 9" },
        { "value": "10", "label": "Round 10" },
        { "value": "11", "label": "Round 11" },
        { "value": "12", "label": "Round 12" },
        { "value": "13", "label": "Round 13" },
        { "value": "14", "label": "Round 14" },
        { "value": "15", "label": "Round 15" },
        { "value": "16", "label": "Round 16" },
        { "value": "17", "label": "Round 17" },
        { "value": "18", "label": "Round 18" },
        { "value": "19", "label": "Round 19" },
        { "value": "20", "label": "Round 20" },
        { "value": "21", "label": "Round 21" },
        { "value": "22", "label": "Round 22" },
        { "value": "23", "label": "Round 23" },
        { "value": "24", "label": "Round 24" }
      ],
      filteredData: [],
      filteredDataLong: false,
      selectedRound: { "value": "All", "label": "All Rounds" },
      selectedTeam: { label: "All Teams", value: "All" },
      selectedSort: 'round',
      selectedSortDirection: 'asc',
      teamOptions: [
        { "value": "All", "label": "All Teams" },
        { "value": "Adelaide", "label": "Adelaide" },
        { "value": "Brisbane Lions", "label": "Brisbane Lions" },
        { "value": "Carlton", "label": "Carlton" },
        { "value": "Collingwood", "label": "Collingwood" },
        { "value": "Essendon", "label": "Essendon" },
        { "value": "Fremantle", "label": "Fremantle" },
        { "value": "Geelong", "label": "Geelong" },
        { "value": "Gold Coast SUNS", "label": "Gold Coast SUNS" },
        { "value": "GWS Giants", "label": "GWS Giants" },
        { "value": "Hawthorn", "label": "Hawthorn" },
        { "value": "Melbourne", "label": "Melbourne" },
        { "value": "North Melbourne", "label": "North Melbourne" },
        { "value": "Port Adelaide", "label": "Port Adelaide" },
        { "value": "Richmond", "label": "Richmond" },
        { "value": "St Kilda", "label": "St Kilda" },
        { "value": "Sydney Swans", "label": "Sydney Swans" },
        { "value": "West Coast", "label": "West Coast" },
        { "value": "Western Bulldogs", "label": "Western Bulldogs" }
      ],
      // preselect: null,
      activeCard: null,
      // screenWidth: window.innerWidth,
      siteDomain: window.location.hostname.replace('www.','').replace('.com.au',''), //  codesports
      isMobApp: false
    }

    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    // const screenWidth = window.innerWidth;
    // console.log("Screen width: ", screenWidth, " pixels");
    
  }

  componentDidMount () {
    // this.checkdate()
    this.loadData()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  checkdate() {
    
    const urlParams = new URLSearchParams(window.location.search);
    const override = urlParams.get('override');
    // console.log('override', override)
    const currentTime = (override) ? override : Date.now();
    // console.log( 'currentTime', currentTime )

    let whichDay = null;

    if ( currentTime < 1724965200000 ) { // til Friday August 30 7am
      whichDay = { "value": "1", "label": "DAY 1 - 29-Aug" }
    } else if ( currentTime >= 1724965200000 && currentTime < 1725051600000 ) { // til Saturday August 31 7am
      whichDay = { "value": "2", "label": "DAY 2 - 30-Aug" }
    } else if ( currentTime >= 1725051600000 && currentTime < 1725138000000 ) { // til Sunday September 1 7am
      whichDay = { "value": "3", "label": "DAY 3 - 31-Aug" }
    } else if ( currentTime >= 1725138000000 && currentTime < 1725224400000 ) { // til Monday September 2 7am
      whichDay = { "value": "4", "label": "DAY 4 - 1-Sep" }
    } else if ( currentTime >= 1725224400000 && currentTime < 1725310800000 ) { // til Tuesday September 3 7am
      whichDay = { "value": "5", "label": "DAY 5 - 2-Sep" }
    } else if ( currentTime >= 1725310800000 && currentTime < 1725397200000 ) { // til Wednesday September 4 7am
      whichDay = { "value": "6", "label": "DAY 6 - 3-Sep" }
    } else if ( currentTime >= 1725397200000 && currentTime < 1725483600000 ) { // til Thursday September 5 7am
      whichDay = { "value": "7", "label": "DAY 7 - 4-Sep" }
    } else if ( currentTime >= 1725483600000 && currentTime < 1725570000000 ) { // til Friday September 6 7am
      whichDay = { "value": "8", "label": "DAY 8 - 5-Sep" }
    } else if ( currentTime >= 1725570000000 && currentTime < 1725656400000 ) { // til Saturday September 7 7am
      whichDay = { "value": "9",  "label": "DAY 9 - 6-Sep" }
    } else if ( currentTime >= 1725656400000 && currentTime < 1725742800000 ) { // til Sunday September 8 7am
      whichDay = { "value": "10", "label": "DAY 10 - 7-Sep" }
    } else if ( currentTime < 1725742800000 ) { // after Sunday September 8 7am
      whichDay = { "value": "11",  "label": "DAY 11 - 8-Sep" }
    } else {
      whichDay =  { "value": "All", "label": "All Rounds" }
    }
      
    this.setState({
      selectedRound: whichDay,
    })

  }

  loadData () {
    
    fetch(apiURL_storage)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const titlesRemoved = data.values.length ? data.values.slice(1) : [];
        const cleanData = titlesRemoved.filter((card) => card.length);
        
        // Transform data
        const dataPaired = cleanData.map((game, index) => ({
          id: index,
          round: parseInt(game[0], 10),
          teamHome: game[1] ? game[1] : '',
          teamHomeClass: game[1] ? game[1].replaceAll(' ', '-') : '',
          teamAway: game[2] ? game[2] : '',
          teamAwayClass: game[2] ? game[2].replaceAll(' ', '-') : '',
          date: game[3] ? game[3] : '',
          time: game[4] ? game[4] : '',
          venue: game[5] ? game[5] : '',
          watch: game[6] ? game[6] : '',
          highlight: game[7] ? game[7] : '',
          blurb: game[8] ? game[8] : '',
        }));

        // Unique sports
        // const uniqueSports = new Set(dataPaired.map(event => event.sport));

        const dataSorted = this.sortByKey(dataPaired, this.state.selectedSort, this.state.selectedSortDirection);
        const isMobApp = !['mobile', 'desktop'].includes(document.body.getAttribute('data-device'));
        this.setState({ data: dataSorted, isMobApp }, this.filterList);
      })
      .catch((error) => console.error('Error fetching data:', error));

  }

  changeRound (e) {
    this.setState({
      selectedRound: e
    }, () => {
      this.filterList()
    })
    
  }

  changeSport (e) {
    const team = e
    this.setState({
      selectedTeam: team
    }, () => {
      this.filterList()
    })
  }

  filterList () {
    // console.log('time to filter')
    // console.log('selectedRound', this.state.selectedRound)
    // console.log('selectedTeam', this.state.selectedTeam)
    // console.log(' this.state.data',  this.state.data)

    const filteredList = this.state.data.filter((record) => {
      // console.log('record', record)
      // IF ALL ROUNDS and ALL TEAMS
      if ( this.state.selectedRound.value == 'All' && this.state.selectedTeam['value'] == 'All' ) {
        // console.log('IF ALL DATES and ALL SPORTS');
        return record //record.stat == this.state.selectedTeam['value']
      } 
      // IF ALL ROUNDS and A TEAM
      if ( this.state.selectedRound.value == 'All' && ( this.state.selectedTeam['value'] == record.teamHome || this.state.selectedTeam['value'] == record.teamAway ) ) {
        // console.log('IF ALL DATES and A TEAM');
        return record
      }
      // IF A ROUND and ALL TEAMS
      else if ( this.state.selectedRound.value == record.round && this.state.selectedTeam['value'] == 'All') {
        // console.log('IF A DATE and ALL TEAMS', record.state, this.state.selectedStates );
        return record
      } 
      // IF A ROUND and A TEAM
      else if ( this.state.selectedRound.value == record.round && ( this.state.selectedTeam['value'] == record.teamHome || this.state.selectedTeam['value'] == record.teamAway ) ) {
        // console.log('IF A DATE and A TEAM');
        return record
      }
      
    })

    // console.log(' filteredList',  filteredList)
    // const dataSorting = this.sortByKey(filteredList, this.state.selectedSort, this.state.selectedSortDirection)

    const isfilteredDataLong = filteredList.length > 20 ? true : false

    this.setState({
      // filteredData: dataSorting
      filteredData: filteredList,
      filteredDataLong: isfilteredDataLong
    })

  }

  /* LOAD READER RANKING */
  sortByKey (array, key, ascdesc) {
    return array.sort((a, b) => {
      let x = (ascdesc === 'asc') ? b[key] : a[key]
      let y = (ascdesc === 'asc') ? a[key] : b[key]
      return -((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }

  expandCard (e) {
        
    const targetRow = e.target.closest('.nnd-tile')
    const targetSection = targetRow.querySelector('.nnd-tile-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-sched-tile')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-tile.nnd-active")

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      this.setState({
        activeCard: null
      }, function () {
        targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      if (existActiveRow) {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-sched-tile').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        currentCard.style.height = targetImageHeight + 'px'
        targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  render() {
    const itemTiles = (typeof this.state.filteredData !== 'undefined') ? this.state.filteredData.map((item) => {
      if (typeof this.state.data !== 'undefined') {
        return (

          item.teamHome == 'BYE' || item.teamHome == 'HEADER'
          ?
            <div key={item.id} className={`nnd-tile nnd-${item.teamHome} nnd-round-${item.round}`}>
              <div className='nnd-sched-tile'>
                <div className="nnd-cta">
                  <div className="nnd-cta-item">
                    <span className="nnd-cta-game">
                      {item.teamHome == 'BYE'
                      ?
                      <span className="nnd-cta-round-team bye">
                        <span className="nnd-cta-round">R{ item.round } {/*<span className="nnd-cta-roundBox">{ item.round }</span>*/}</span>
                        <span className="nnd-cta-byeTitle">Bye: { item.blurb }</span>
                      </span>
                      :
                      <span className="nnd-cta-round-team nnd-roundHeader">
                        <h4 className="nnd-cta-round">Round { item.round }</h4>
                      </span>
                      }

                    </span>
                  </div>
                </div>
              </div>
            </div>
          :
            <div key={item.id} className={`nnd-tile nnd-round-${item.round}`} onClick={(e) => { this.expandCard(e); /*e.preventDefault()*/ }} >
              <div className='nnd-sched-tile'>
                <div className="nnd-cta">
                  <h4 className="nnd-cta-item">
                    <span className="nnd-cta-game">
                      <span className="nnd-cta-round-team">
                        <span className="nnd-cta-round">R{item.round} {/*<span className="nnd-cta-roundBox">{ item.round }</span>*/}</span>
                        <span className="nnd-cta-gameTitle">{ item.teamHome } vs { item.teamAway }<span className="nnd-sport-gameTitleExtra">, { item.date }, { item.time }</span></span></span>
                        {item.highlight !== '' && ( <span className="nnd-highlight"></span> )}
                    </span>
                  </h4>
                  <div className="nnd-cta-icon" data-index={item.id}>
                    <div className="nnd-cta-icon_plus"></div>
                    <div className="nnd-cta-icon_plus_vertical"></div>
                  </div>
                </div>
              </div>
              <div className='nnd-sched-tile-expanded'>
                <div className="nnd-tile-content">
                  <div className="nnd-tile-content-inner">   
                    <div className="nnd-tile-text" >
                      <div className="nnd-details">
                        <div className="nnd-matchTeams">
                          <div className="nnd-matchTeam nnd-matchTeam1">
                            <div className={`nnd-teamLogo ${item.teamHomeClass}`}></div>
                            <h3>{ item.teamHome }</h3>
                          </div>
                          <div className="nnd-vs">VS</div>
                          <div className="nnd-matchTeam nnd-matchTeam2">
                            <div className={`nnd-teamLogo ${item.teamAwayClass}`}></div>
                            <h3>{ item.teamAway }</h3>
                          </div>
                        </div>
                        <h5>{ item.date } - { item.time }</h5>
                        {item.venue && ( <p><span>Venue:</span> {item.venue}</p> )}
                        {item.watch && ( <p><span>Watch:</span> {item.watch}</p> )}
                        {item.highlight && ( <p><span>Highlight:</span> {item.highlight}</p> )}
                        {item.blurb && ( <p>{item.blurb}</p> )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        )
      }
    }) : ''

    const siteDomain = this.state.siteDomain
    const isActiveCard = this.state.activeCard
    const isMobApp = this.state.isMobApp

    return (
      <div id="nnd-container" className={`nnd-site-${siteDomain ? siteDomain : ""} nnd-app-${isMobApp ? isMobApp : ""} `}>
        <div className="nnd-headerMain">
          <h3>AFL Schedule 2025</h3>
        </div>

        <div className="nnd-navigation">
          <Select 
            onChange={event => this.changeRound(event)} 
            className="nnd-round" 
            classNamePrefix="nnd-select" 
            // isMulti 
            options={this.state.roundOptions} 
            // placeholder={'All Dates'}
            value={this.state.selectedRound}
          />
              
          <Select 
            onChange={event => this.changeSport(event)} 
            className="nnd-team" 
            classNamePrefix="nnd-select" 
            options={this.state.teamOptions} 
            value={this.state.selectedTeam}
          />
        </div>
        
        <div className="nnd-cont-main-wrap" data-long={ this.state.filteredDataLong }>
          <div className="nnd-cont-main" ref="scroller">
            <div className={isActiveCard !== null ? 'nnd-tiles nnd-activeCard' : 'nnd-tiles'} >
              {itemTiles.length
              ?
                itemTiles
              :
                <div className="nnd-tiles">
                  <div className="nnd-noTile-message">There are no games scheduled yet for this round or team</div>
                </div>
              }
            </div>
          </div>
        </div>

        <div className="nnd-footer"></div>

      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js